<script lang="ts">
  // How to switch on Historical Data on Garmin's page, before going there. Garmin leaves it off and
  // only the athlete can turn it on, so Xert can only explain it. The same steps as the account
  // setup wizard's dialog.
  import { Button } from '$lib/components/ui/button'
  import * as Dialog from '$lib/components/ui/dialog'
  import { focusMainButton } from '@/Util/utils'

  export let open = false
  export let redirect: string
  export let cta = 'Continue to Garmin'

  $: if (open) focusMainButton()
</script>

<Dialog.Root portal="#shadcn-ui-dialog-target" bind:open>
  <Dialog.Content class="max-h-[95dvh] max-w-lg overflow-y-auto">
    <Dialog.Header>
      <Dialog.Title>Switch on Historical Data</Dialog.Title>
      <Dialog.Description>
        Xert needs <strong>Historical Data</strong> to receive your past activities from Garmin. Garmin leaves it switched off,
        and only you can turn it on, on Garmin's page.
      </Dialog.Description>
    </Dialog.Header>
    <div class="flex flex-col items-start gap-4 sm:flex-row">
      <ol class="m-0 flex-1 list-decimal space-y-2 pl-5 text-sm text-foreground">
        <li>Click <strong>{cta}</strong> and sign in.</li>
        <li>Under <em>Data shared from Garmin to the Xert app</em>, switch on <strong>Historical Data</strong>.</li>
        <li>Click <strong>Save</strong>.</li>
      </ol>
      <div class="relative w-56 shrink-0 self-center overflow-hidden rounded-md border border-border bg-white shadow-sm sm:self-start">
        <img src="/assets/images/providers/garmin_historical_data.png" alt="Garmin's page, with the Historical Data switch off" class="block w-full" />
        <span class="pointer-events-none absolute left-[19%] top-[50.2%] h-[6.6%] w-[47%] animate-pulse rounded border-2 border-amber-500" aria-hidden="true" />
      </div>
    </div>
    <p class="m-0 text-xs text-muted-foreground">
      Without it Xert only receives the activities you record from now on. You can still upload activity files on the
      <a href="/activities/upload" class="rounded-sm text-primary underline-offset-2 outline-none focus-visible:ring-2 focus-visible:ring-ring hover:underline">Upload Activity page</a>.
    </p>
    <Dialog.Footer class="gap-2">
      <Button variant="outline" on:click={() => (open = false)}>Not now</Button>
      <Button href={redirect} data-main-button>{cta}</Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
